import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import AbstractCommand from "../../application/AbstractCommand";
import LanguagePackAddedEvent from "./LanguagePackAddedEvent";
import LanguagePackLoadedEvent from "./LanguagePackLoadedEvent";

export default class AddLanguagePackCommand extends AbstractCommand {
    constructor(languagePack, dispatcher){
        super(dispatcher);
        this._languagePack = languagePack;
    }

    execute(evt){
        /** @type {LanguagePackLoadedEvent} */
        const data = evt.params.data;
        const newLanguagePack = new LanguagePack();
        newLanguagePack.setPropertiesFromObject(data.lpJson);
        this._languagePack.merge(newLanguagePack, true);
        
        const languageEvt = new LanguagePackAddedEvent(evt.id, evt.url, newLanguagePack);
        this.dispatch(LanguagePackAddedEvent.ADDED, { data: languageEvt });
    }
}